"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSummaryExpandable = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const TableSummaryExpandable = ({ title, children, id, }) => {
    const [isExpanded, setExpanded] = react_1.default.useState(true);
    return (react_1.default.createElement(react_core_1.ExpandableSection, { toggleContent: react_1.default.createElement("b", null, title), isExpanded: isExpanded, onToggle: () => setExpanded(!isExpanded), isIndented: true, id: id ? id : title },
        children,
        react_1.default.createElement("br", null)));
};
exports.TableSummaryExpandable = TableSummaryExpandable;
//# sourceMappingURL=TableSummaryExpandable.js.map